import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormInput from '../../../../../library/form/components/FormInput';
import FormButton from '../../../../../library/form/components/FormActionButton2';
import SarasTrans from '../../../../../library/notifications/SarasTrans';


const BudgetSearchBatchAction = (props) => {
    const { formObject, selectedDids, reloadSearch } = props;

    const onActionSuccess = () => {
        if(reloadSearch)reloadSearch(1);
    }

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch(1);
    }

    return (
            <div className="uiFlexBox">
                <FormInput formObject={formObject} rowKey="" className="uiInput uiSpacerH5" style={{ width: "100px" }} 
                    placeholder="Job Order Id" action={{ InputType: "input", paramName: "refDocId"}}
                />
                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                    action={{ actionId: "refresh",  paramName: "batchAction", 
                    actionParam: {actionType: "linkJO", tdtId: "1501", tdId: "#refDocId", is:"4", dIds:selectedDids.join(","), dtId:"%dataList.valLDT"},
                    onSuccess:onActionSuccess}}
                    text={<SarasTrans value="Link Job Order" />}></FormButton>
                <FormButton formObject={formObject} rowKey="" className="uiActionButton"
                    starIcon="adds"
                    action={{ actionId: "new", actionName:"prodComp",  paramName: "batchAction", containerKey: "popup", onModalClose:onPopupClose,
                    actionParam: {actionType: "CreateProdFromBudget", tdtId: "1501", is:"4", dIds:selectedDids.join(","), dtId:"%dataList.valLDT"} }}
                    text={<SarasTrans value="Create Job Order" />}></FormButton>
            </div>
    )
}

export default withView(BudgetSearchBatchAction, "budgetComp", "");
